module.exports = __webpack_public_path__ + "img/my-pools-night@2x.f1b6c27c.png";